export { default as LogoMarks } from './LogoMarks';
